declare namespace $ {

	export class $bog_max_list extends $mol_list {
	}
	
}

//# sourceMappingURL=list.view.tree.d.ts.map